import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import ActionDialog from '@src/new-components/Dialog/ActionDialog';

const StyledPolicyDialog = styled(ActionDialog)`
  .MuiDialog-paper {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 600px) {
    .dialog-wrapper {
      gap: 16px;
      padding: 16px;
    }

    .content-wrapper {
      width: 100%;
      gap: 12px;
    }

    .dialog-action-single {
      width: 100%;
      margin-top: 4px;
    }
  }
`;

const StyledConsent = styled('div')`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;

  .policy-consent-checkbox {
    padding: 4px;
    margin-top: 0;
  }

  .policy-consent-checkbox.Mui-checked {
    color: ${COLOR.blueV2};
  }

  .policy-consent-label {
    flex: 1;
    min-width: 0;
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.4px;
    color: ${COLOR.darkGray};
  }

  .policy-consent-label b,
  .policy-consent-label strong {
    font-weight: 700;
  }

  .policy-consent-label a {
    color: ${COLOR.blueV2};
    text-decoration: underline;
    font-weight: 400;
  }
`;

const StyledAction = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;

  @media (max-width: 600px) {
    .policy-confirm-button {
      width: 100%;
    }
  }
`;

export { StyledAction, StyledConsent, StyledPolicyDialog };
